<template>
  <svg
    height="40"
    width="40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 511.998 511.998"
    xml:space="preserve"
  >
  <!-- Circle background -->
  <circle cx="256" cy="256" r="248" fill="#1E2A78"/>

  <!-- Centered UN text -->
  <text x="50%" y="50%"
        text-anchor="middle"
        dominant-baseline="central"
        font-size="220"
        font-weight="700"
        font-family="Arial, Helvetica, sans-serif"
        fill="white"
        letter-spacing="-10">UN</text>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>